import React from 'react';
import { useSelector } from 'react-redux';
import Pricing from './Pricing';
import PublicPricing from './PublicPricing';

// Zalogowany kupuje przez dotychczasowy proces PayU, gość widzi publiczny cennik
function PricingRoute() {
  const userInfo = useSelector(state => state.userLogin.userInfo);
  // Pricing.js ma style z ciemnego motywu (text-white) — .app zamienia je na kolory A1
  return userInfo?.token ? <div className="app pub-wrap py-4"><Pricing /></div> : <PublicPricing />;
}

export default PricingRoute;
